import React from "react";

const NextButtonVector = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5998 9.9564e-05C13.787 3.71417e-05 13.9683 0.0656542 14.1122 0.185523C14.256 0.305392 14.3533 0.471917 14.387 0.656099L14.3998 0.8001V15.2001C14.4001 15.4 14.3256 15.5928 14.191 15.7406C14.0563 15.8883 13.8712 15.9802 13.6721 15.9983C13.473 16.0164 13.2743 15.9592 13.1152 15.8381C12.9562 15.7171 12.8482 15.5408 12.8126 15.3441L12.7998 15.2001V0.8001C12.7998 0.587926 12.8841 0.384443 13.0341 0.234414C13.1841 0.0843852 13.3876 9.9564e-05 13.5998 9.9564e-05ZM1.03337 0.233699C1.16594 0.101419 1.34071 0.0198402 1.52725 0.00317497C1.71378 -0.0134903 1.90025 0.0358149 2.05417 0.1425L2.16617 0.233699L9.36617 7.4337C9.49845 7.56627 9.58003 7.74104 9.59669 7.92758C9.61336 8.11411 9.56406 8.30058 9.45737 8.4545L9.36617 8.5665L2.16617 15.7665C2.02507 15.9082 1.83599 15.992 1.63621 16.0012C1.43643 16.0105 1.24043 15.9446 1.08684 15.8165C0.933245 15.6884 0.833202 15.5074 0.806425 15.3092C0.779647 15.111 0.828077 14.91 0.94217 14.7457L1.03337 14.6337L7.66857 8.0001L1.03337 1.3665C0.958868 1.29219 0.899759 1.20391 0.859429 1.10671C0.819099 1.00952 0.79834 0.905327 0.79834 0.8001C0.79834 0.694872 0.819099 0.590678 0.859429 0.493486C0.899759 0.396293 0.958868 0.308013 1.03337 0.233699Z"
        fill="#1E1E1E"
      />
    </svg>
  );
};

export default NextButtonVector;
